import React from 'react';

// Shows where an account's balance comes from, and flags what needs a look:
// "Unverified balance" (typed in, no starting balance, no bank feed) and a
// deposit account below zero. Values come from the accounts API (utils/balanceSource).
const day = (v) => (v ? String(v).slice(0, 10) : '');

export function balanceSourceLabel(account) {
  const a = account || {};
  if (a.balance_source === 'bank_feed') return 'From bank feed';
  if (a.balance_source === 'starting_balance') return `Calculated from starting balance (${day(a.balance_as_of)})`;
  return `Manual as of ${day(a.balance_as_of) || 'unknown date'}`;
}

export function isBalanceLocked(account) {
  const a = account || {};
  return a.balance_source === 'bank_feed' || a.balance_source === 'starting_balance' || !!a.opening_balance_date;
}

export function BalanceWithSource({ account, format }) {
  const a = account || {};
  return (
    <span>
      {format(a.current_balance)}
      <span className="block text-xs font-normal text-gray-500">{balanceSourceLabel(a)}</span>
      {a.provisional_start && <span className="block text-xs font-medium text-amber-700" title={a.opening_balance_note || ''} data-testid="provisional-start">Provisional starting balance</span>}
      {a.balance_unverified && <span className="block text-xs font-medium text-amber-700" title="No starting balance and no bank feed">Unverified balance</span>}
      {a.negative_balance_review && <span className="block text-xs font-medium text-red-700" role="alert">Negative balance: review this account</span>}
    </span>
  );
}

export function UnverifiedTotal({ accounts, format }) {
  const first = (accounts || [])[0];
  const count = Number(first?.unverified_count || 0);
  if (!count) return null;
  return (
    <div className="rounded border border-amber-300 bg-amber-50 p-3 text-sm text-amber-800" data-testid="unverified-total">
      {count} account{count === 1 ? '' : 's'} with an unverified balance ({format(first.unverified_signed_total)} of the net total). Add a starting balance or link the bank to verify.
    </div>
  );
}
